module.exports = __webpack_public_path__ + "static/media/Racoon.84f9db90.png";